export default __webpack_public_path__ + "static/media/soltangalano.27f980ea.jpeg";